import { styled } from '@mui/system';
import { CardContent, Typography } from '@mui/material';

export const StyledCard = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  height: '100%',
  padding: '0 1rem',
  alignItems: 'center',
  gap: theme.spacing(2),
}));

export const StyledCardContent = styled(CardContent)(() => ({
  textAlign: 'left',
  padding: '0 !important',
}));

export const OvertimeText = styled(Typography)(() => ({
  color: 'rgba(235, 235, 245, 0.6)',
}));

export const WhiteText = styled(Typography)(() => ({
  color: 'white',
}));
